import React, { FC } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import Icon404 from '@/public/images/error/404.svg';
import Icon403 from '@/public/images/error/403.svg';
import Icon503 from '@/public/images/error/503.svg';
import Icon500 from '@/public/images/error/500.svg';
import IconMaintain from '@/public/images/error/maintain.svg';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import styles from './CustomErrors.module.scss';
import { useIsWhiteLabel } from '@/components/app/providers/whiteLabelProvider/WhiteLabelProvider';
type ErrorTypes = {
  type: 'MAINTENANCE' | 'SERVER_NOT_READY' | 'UNAUTHORIZED' | 'NOT_FOUND' | 'SERVER_PROBLEM';
};
const types = {
  NOT_FOUND: {
    title: 'نتیجه ای برای شما یافت نشد',
    desc: 'نتیجه ای برای مشاهده یافت نشد لطفا عنوان جستجو را تغییر دهید.',
    image: Icon404
  },
  UNAUTHORIZED: {
    title: 'مسیر دسترسی مسدود است!',
    desc: '',
    image: Icon403
  },
  SERVER_NOT_READY: {
    title: 'راه‌های ارتباطی در شب به طور موقت قطع شده است!',
    desc: 'لطفاً لحظاتی دیگر دوباره تلاش کنید',
    image: Icon503
  },
  SERVER_PROBLEM: {
    title: 'خطای سرور',
    desc: 'مشکلی در سمت سرور به وجود آمده است',
    image: Icon500
  },
  MAINTENANCE: {
    title: 'سایت در حال بروزرسانی می باشد',
    desc: 'درحال بروزرسانی وبسایت جهت خدمت رسانی بهتر به شما هستیم، لطفا دقایقی دیگر مجددا امتحان کنید.',
    image: IconMaintain
  }
};
const CustomErrors: FC<ErrorTypes> = ({
  type
}) => {
  const data = types[type] ?? types['MAINTAIN'];
  const isWhiteLabel = useIsWhiteLabel();
  return <Box className={styles['container']} data-sentry-element="Box" data-sentry-component="CustomErrors" data-sentry-source-file="CustomErrors.tsx">
      {!isWhiteLabel && <Box className={styles['errors-header']}>
          <Image src={'/images/logo-shab.svg'} alt={'سایت شب  | shab'} width={100} height={32} />
        </Box>}
      <Box className={styles['errors-body']} data-sentry-element="Box" data-sentry-source-file="CustomErrors.tsx">
        <Box className={styles['errors-img-container']} data-sentry-element="Box" data-sentry-source-file="CustomErrors.tsx">
          <Image src={data.image} alt={data.title} layout={'responsive'} data-sentry-element="Image" data-sentry-source-file="CustomErrors.tsx" />
        </Box>
        <Box className={styles['errors-text-container']} data-sentry-element="Box" data-sentry-source-file="CustomErrors.tsx">
          <Typography variant={'headlineM_Bold'} data-sentry-element="Typography" data-sentry-source-file="CustomErrors.tsx">{data.title}</Typography>
          <Typography variant={'bodyL'} color={'neutral_600'} data-sentry-element="Typography" data-sentry-source-file="CustomErrors.tsx">
            {data.desc}
          </Typography>
        </Box>
      </Box>
      <Link href={'/'} className={styles['home-link']} data-sentry-element="Link" data-sentry-source-file="CustomErrors.tsx">
        صفحه اصلی
      </Link>
    </Box>;
};
export default CustomErrors;